// src/pages/stockin/hooks/useStockInData.js
import {useState, useEffect} from "react";
import moment from "moment";
import api from "../../../helpers/api";

export const useStockInData = (initialPage = 0, initialRowsPerPage = 10) => {
  const [stockInList, setStockInList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [branchCodeSelected, setBranchCodeSelected] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("desc");
  const [error, setError] = useState(null);

  const getStockInList = async () => {
    const currentPage = page + 1;
    setIsLoading(true);
    setError(null);

    try {
      // Format dates untuk API call dengan moment
      const dateFrom = selectedDateFrom
        ? moment(selectedDateFrom).format("YYYY-MM-DD")
        : "";
      const dateTo = selectedDateTo
        ? moment(selectedDateTo).format("YYYY-MM-DD")
        : "";

      const res = await api.getStockInData(
        branchCodeSelected,
        "", // productCode (empty string default)
        dateFrom, // selectedDateFrom
        dateTo, // selectedDateTo
        rowsPerPage, // pageSize
        currentPage // currentPage
      );

      if (res.statusCode === 200) {
        setStockInList(res.data.data);
        setTotalRecord(res.data.totalPage * res.data.limit);
      } else {
        setStockInList([]);
        setError(res.message);
      }
    } catch (err) {
      setStockInList([]);
      setError(err.message || "Failed to fetch stock in data");
    } finally {
      setIsLoading(false);
      setIsReload(false);
    }
  };

  // Handle sorting
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";

    const sortedData = [...stockInList].sort((a, b) => {
      const valueA = a[property];
      const valueB = b[property];

      if (typeof valueA === "string") {
        return newOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return newOrder === "asc" ? valueA - valueB : valueB - valueA;
    });

    setStockInList(sortedData);
    setOrder(newOrder);
    setOrderBy(property);
  };

  // Load on page or rows per page change
  useEffect(() => {
    getStockInList();
  }, [page, rowsPerPage]);

  // Reload when isReload is true
  useEffect(() => {
    if (isReload) {
      getStockInList();
    }
  }, [isReload]);

  return {
    stockInList,
    isLoading,
    totalRecord,
    branchCodeSelected,
    setBranchCodeSelected,
    selectedDateFrom,
    setSelectedDateFrom,
    selectedDateTo,
    setSelectedDateTo,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    orderBy,
    order,
    error,
    getStockInList,
    setIsReload,
    handleRequestSort,
  };
};

export default useStockInData;
